import dayjs from "dayjs";

import { useMemo } from "react";

import { Breadcrumbs, Checkbox, Chip, Skeleton, Typography } from "@mui/material";

import HorizontalScrollBar from "@/components/HorizontalScrollBar";
import ProChip from "@/components/ProChip";
import { useGlobalStoreContext } from "@/context/globalStoreContext";
import useThemeData from "@/hooks/useThemeData";

import { useFilterContext } from "../FilterContext";
import { completeDateArray } from "../utils/completeDateArray";

const FilterItemDatesV2 = () => {
  const store = useGlobalStoreContext();
  const { filterData, setFilterData, filterOptions, datePriceMap, loading } = useFilterContext();
  const proChipWidth = "42px";
  const theme = useThemeData();

  const options = useMemo(() => {
    if (Number(store.user_type) === 0) {
      return completeDateArray(filterOptions?.datesOptions?.map?.((item) => item.label) ?? []);
    }

    return filterOptions?.datesOptions?.map?.((item) => item.label) ?? [];
  }, [filterOptions?.datesOptions, store.user_type]);

  const handleChange = (value: string, isSelected: boolean) => {
    let newValue = [];

    if (isSelected) {
      newValue = [...filterData.date, value];
    } else {
      const options =
        filterData.date.length === 0
          ? filterOptions.datesOptions.map((item) => item.label)
          : filterData.date;

      newValue = options.filter((v) => v !== value);
    }

    setFilterData({
      ...filterData,
      date: newValue.length === filterOptions.datesOptions.length ? [] : newValue,
    });
  };

  if (options.length < 2) {
    return null;
  }

  return (
    <div className="mt-[5px] mb-[3px]">
      <HorizontalScrollBar>
        <div className="w-[100%] text-center">
          <Breadcrumbs
            className="inline-block"
            maxItems={10000}
            separator=""
            aria-label="breadcrumb"
            sx={{
              ".MuiBreadcrumbs-ol": {
                flexWrap: "nowrap",
              },
              ".MuiBreadcrumbs-separator": {
                margin: "0 4px",
              },
            }}
          >
            {options.map((item) => {
              const val = datePriceMap?.get(item)?.awardPoints ?? 0;
              const tax = Math.ceil(datePriceMap?.get(item)?.tax ?? 0);

              const isExist = filterOptions.datesOptions.find(({ label }) => label === item);

              const isSelected =
                Number(store.user_type) === 0 && isExist && filterData.date.length === 0
                  ? true
                  : Number(store.user_type) === 1 && filterData.date.length === 0
                  ? true
                  : filterData.date.includes(item);

              return (
                <Chip
                  key={item}
                  size="small"
                  color={isSelected ? "primary" : undefined}
                  variant={"outlined"}
                  onClick={() => {
                    if (!isExist) {
                      window.open("/pro", "_blank");
                      return;
                    }

                    handleChange(item, !isSelected);
                  }}
                  sx={{
                    width: "110px",
                    height: "72px",
                    padding: "0px",
                    borderRadius: "5px",
                    textAlign: "center",
                    "& .MuiChip-label": {
                      display: "block",
                      width: "100%",
                      padding: 0,
                      whiteSpace: "normal",
                    },
                  }}
                  label={
                    <div style={{ fontSize: "14px", width: "100%" }}>
                      <div>
                        {dayjs(item).format("ddd MM/DD")}
                        <Checkbox
                          checked={isSelected}
                          className="!p-0"
                          size="small"
                          sx={{ transform: "scale(0.8)", marginBottom: 0.2 }}
                        />
                      </div>
                      <div className="flex justify-center space-x-[0px] mt-[-5px]">
                        <a
                          className="cursor-pointer"
                          onClick={(e) => {
                            if (!isExist) {
                              return;
                            }
                            e.stopPropagation();
                            setFilterData({
                              ...filterData,
                              date: [item],
                            });
                          }}
                        >
                          Only
                        </a>
                      </div>

                      <div
                        style={{
                          width: "100%",
                          height: "1px",
                          backgroundColor: theme.isDarkMode
                            ? "rgb(97, 97, 97)"
                            : "rgb(169, 169, 169)",
                          marginTop: "3px",
                          marginBottom: "3px",
                        }}
                      />

                      {loading && !val ? (
                        Number(store.user_type) === 0 ? (
                          isExist ? (
                            <Skeleton animation="wave" width="65%" sx={{ margin: "0 auto" }} />
                          ) : (
                            <ProChip nomargin height={"20px"} width={proChipWidth} openPage={false} />
                          )
                        ) : (
                          <Skeleton animation="wave" width="65%" sx={{ margin: "0 auto" }} />
                        )
                      ) : Number(store.user_type) === 0 ? (
                        isExist ? (
                          <div>{`${Number(val / 1000).toLocaleString()}k+$${tax}`}</div>
                        ) : (
                          <ProChip nomargin height={"20px"} width={proChipWidth} openPage={false} />
                        )
                      ) : (
                        <div>{`${Number(val / 1000).toLocaleString()}k+$${tax}`}</div>
                      )}
                    </div>
                  }
                />
              );
            })}
          </Breadcrumbs>
        </div>
      </HorizontalScrollBar>
    </div>
  );
};

export default FilterItemDatesV2;
